module.exports = __webpack_public_path__ + "img/napravlen-3.ed64f579.png";